module.exports = __webpack_public_path__ + "static/og-80a4d3c210499a5b3557e17b9a56beb8.png";